module.exports = __webpack_public_path__ + "static/media/banner_6.45a6f677.jpg";